import {
  TabCount,
  TabItem,
  TabsWrapper,
} from 'modules/Drive/Partials/DriveTabs/Style/style'
import React from 'react'
const DriveTabs = ({
  selected,
  selectedType,
  count = 0,
  activeCount,
  onHold,
  rejectedCount,
}) => {
  const selectiontype = selected

  return (
    <TabsWrapper>
      <TabItem
        isActive={selectiontype == 'active'}
        onClick={() => {
          selectedType('active')
        }}
      >
        Active <TabCount>{activeCount}</TabCount>
      </TabItem>
      <TabItem
        isActive={selectiontype == 'onhold'}
        onClick={() => {
          selectedType('onhold')
        }}
      >
        OnHold <TabCount>{onHold}</TabCount>
      </TabItem>
      <TabItem
        isActive={selectiontype == 'rejected'}
        onClick={() => {
          selectedType('rejected')
        }}
      >
        Rejected <TabCount>{rejectedCount}</TabCount>
      </TabItem>
    </TabsWrapper>
  )
}

export default DriveTabs
